import { createElement } from 'react';
import { Form, Box, Button, Radio, Input, Typography, Tag, Icon } from '@alifd/next';
const UcmlFlowVC = function UcmlFlowVC({ ...otherProps }) {
    const FormItem = Form.Item;
    const { H3, Text } = Typography;
    const onChange = (value) => {
    };
    const formItemLayout = {
        labelCol: {
            fixedSpan: 8
        },
        wrapperCol: {
            span: 14
        }
    };
    return (createElement(React.Fragment, null,
        createElement(H3, null, "\u6D41\u7A0B\u529E\u7406"),
        createElement(Form, { style: { width: "100%" }, ...formItemLayout, colon: true },
            createElement(FormItem, { label: "\u6D41\u7A0B\u64CD\u4F5C" },
                createElement(Box, { direction: "row", spacing: 20 },
                    createElement(Button, { type: "primary" }, "\u4FDD\u5B58"),
                    createElement(Button, { type: "primary" }, "\u5B8C\u6210\u4EFB\u52A1"),
                    createElement(Button, { type: "primary" }, "\u6D4F\u89C8\u610F\u89C1"),
                    createElement(Button, { type: "primary" }, "\u6D41\u7A0B\u8DDF\u8E2A"),
                    createElement(Button, { type: "primary" }, "\u4E0B\u4E00\u6B65"),
                    createElement(Button, { type: "primary" }, "\u9AD8\u7EA7"),
                    "...")),
            createElement(FormItem, { name: "a", label: "\u5BA1\u6279\u610F\u89C1" },
                createElement(Radio.Group, { value: "agree", onChange: onChange, "aria-labelledby": "groupId" },
                    createElement(Radio, { id: "agree ", value: "agree " }, "\u540C\u610F"),
                    createElement(Radio, { id: "disagree", value: "disagree" }, "\u4E0D\u540C\u610F"))),
            createElement(FormItem, { name: "b", label: "\u5F55\u5165\u610F\u89C1" },
                createElement(Input.TextArea, { placeholder: "TextArea", "aria-label": "TextArea" })),
            createElement(FormItem, { name: "c", label: "\u9644\u4EF6" },
                createElement(Box, { direction: "row", spacing: 20 },
                    createElement(Text, { underline: true }, "\u6D41\u7A0B\u5BA1\u6279\u9644\u4EF6"),
                    "   ",
                    createElement(Tag, null,
                        createElement(Icon, { type: "add" }),
                        "\u4E0A\u4F20"))))));
};
export default UcmlFlowVC;
